import constants from '@core/utils/constants';
import { bus } from '@core/events/eventSystem';
import { getStore } from '@core/store';
import { registrationSerializer } from '../registration/registrationSerializer';

const passwordResetRequestIdPrefix = 'password-reset-';
let currentPasswordResetEmail = null;

// initiatePasswordReset - démarrer le processus
function initiatePasswordReset() {
  const requestId = `${passwordResetRequestIdPrefix}${Date.now()}`;

  // utiliser le système OTP existant
  bus.emit(constants.EVENTS.OTP.SEND_OTP, {
    requestId,
    channel: 'email',
    showContactInput: true,
    validate: true
  });

  // écouter la validation OTP pour continuer
  const handler = (data) => {
    if (data.requestId && data.requestId.startsWith(passwordResetRequestIdPrefix)) {
      bus.off(constants.EVENTS.OTP.OTP_VALIDATED, handler);

      currentPasswordResetEmail = data.email;

      // émettre l'événement pour afficher le modal nouveau mot de passe
      bus.emit(constants.EVENTS.PASSWORD_RESET.SHOW_NEW_PASSWORD_INPUT, {
        email: data.email
      });
    }
  };
  bus.on(constants.EVENTS.OTP.OTP_VALIDATED, handler);
}

// listener pour SHOW_NEW_PASSWORD_INPUT (pour gérer le mode migration)
bus.on(constants.EVENTS.PASSWORD_RESET.SHOW_NEW_PASSWORD_INPUT, (data) => {
  currentPasswordResetEmail = data.email;
  // le store gère isMigration et legacyData
});

// listener pour PASSWORD_RESET_REQUESTED
bus.on(constants.EVENTS.PASSWORD_RESET.REQUESTED, () => {
  initiatePasswordReset();
});

// listener pour soumettre le nouveau mot de passe
bus.on(constants.EVENTS.PASSWORD_RESET.SUBMIT_NEW_PASSWORD, async (data) => {
  const { password } = data;

  if (!password || password.length < 6) {
    bus.emit(constants.EVENTS.TOAST_NOTIFICATION.SHOW, {
      title: 'Mot de passe invalide',
      body: 'Le mot de passe doit contenir au moins 6 caractères'
    });
    bus.emit(constants.EVENTS.PASSWORD_RESET.RESET_ERROR, {
      error: 'Mot de passe trop court'
    });
    return;
  }

  const passwordResetStore = getStore('passwordReset');
  const isMigrationMode = passwordResetStore?.state?.isMigration || false;
  const legacyUserData = passwordResetStore?.state?.legacyData || null;

  // si mode migration, créer le compte d'abord
  if (isMigrationMode && legacyUserData) {
    const reqData = registrationSerializer.serialize({
      email: currentPasswordResetEmail,
      password: password,
      firstName: legacyUserData.firstName || 'Utilisateur',
      lastName: legacyUserData.lastName || 'Migré',
      phonePrefix: '229',
      phoneNumber: '',
      acceptMoreThan18: true,
      termOfUse: true
    });

    const requestId = `migration-register-${Date.now()}`;

    bus.emit(constants.EVENTS.NETWORK.REQUEST, {
      id: requestId,
      url: `${constants.ENDPOINTS.USER.REGISTER}`,
      method: 'POST',
      data: reqData
    });

    const handler = (res) => {
      if (res.id === requestId) {
        bus.off(constants.EVENTS.NETWORK.RESPONSE, handler);

        const parsed = registrationSerializer.deserialize(res.data || res.error);

        if (parsed.success) {
          // compte créé avec succès
          bus.emit(constants.EVENTS.USER.REGISTER_SUCCESS, parsed.user);
          bus.emit(constants.EVENTS.PASSWORD_RESET.RESET_SUCCESS);
          bus.emit(constants.EVENTS.LEGACY_MIGRATION.MIGRATION_COMPLETE);

          bus.emit(constants.EVENTS.TOAST_NOTIFICATION.SHOW, {
            title: 'Compte migré',
            body: 'Votre compte a été migré avec succès'
          });

          // nettoyer les anciennes données
          // userMigration.clearLegacyData();
        } else if (parsed.alreadyExists) {
          // le compte existe déjà, faire login direct
          bus.emit(constants.EVENTS.USER.LOGIN, {
            email: currentPasswordResetEmail,
            password: password
          });
        } else {
          bus.emit(constants.EVENTS.LEGACY_MIGRATION.MIGRATION_FAILED);
          bus.emit(constants.EVENTS.TOAST_NOTIFICATION.SHOW, {
            title: 'Erreur de migration',
            body: parsed.message || 'Impossible de créer le compte'
          });
          bus.emit(constants.EVENTS.PASSWORD_RESET.RESET_ERROR, {
            error: parsed.message
          });
        }
      }
    };
    bus.on(constants.EVENTS.NETWORK.RESPONSE, handler);
    return;
  }

  // mode normal: update du mot de passe
  bus.emit(constants.EVENTS.USER.UPDATE, {
    email: currentPasswordResetEmail,
    password: password
  });
});

// listener quand le mot de passe a été mis à jour avec succès
bus.on(constants.EVENTS.USER.UPDATE_SUCCESS, () => {
  // vérifier si on est dans le context d'un password reset
  if (currentPasswordResetEmail) {
    bus.emit(constants.EVENTS.PASSWORD_RESET.RESET_SUCCESS);

    bus.emit(constants.EVENTS.TOAST_NOTIFICATION.SHOW, {
      title: 'Mot de passe modifié',
      body: 'Votre mot de passe a été réinitialisé avec succès'
    });

    currentPasswordResetEmail = null;
  }
});

// listener pour annuler
bus.on(constants.EVENTS.PASSWORD_RESET.CANCEL, () => {
  currentPasswordResetEmail = null;
  // le store gère le reset via l'événement CANCEL
});
